import React from 'react'
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { Box, Typography } from "@mui/material"


export default function ComparatorDiff() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparatorPrices || 0)

	const labelsFormatted = {
		1: { icon: "arrow-up", label: "Higher than", color: "success.main" },
		0: { icon: "arrow-down", label: "Lower than", color: "error.main" },
	}

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		disableClearable
		label="Comparison difference"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_difference`}
		inputProps={{
			startAdornment: <IconSeeker
				icon={labelsFormatted[dataInfo.value].icon}
				sx={{
					color: labelsFormatted[dataInfo.value].color,
					ml: 1,
					mr: .5
				}}
			/>
		}}
		onAjax={options => {
			return options.map(({ value }) => ({
				value: value,
				label: labelsFormatted[value].label,
			}))
		}}
		formatOptionLabel={({ value }) => {
			return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
				<IconSeeker
					icon={labelsFormatted[value].icon}
					sx={{ color: labelsFormatted[value].color }}
				/>
				<Typography>{labelsFormatted[value].label}</Typography>
			</Box>
		}}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparatorPrices')}
	/>
}